import { get_store_value } from "svelte/internal";
import { derived, writable } from "svelte/store";
import { characterStateStore, fetchedStateStore, otherCharacterStateStore, postDataStore, roomFlagsStore, timeStore, userInputStore } from "./state";
export const volumeStore = writable(0.5);
export const gameStateStore = derived([fetchedStateStore, timeStore, roomFlagsStore, characterStateStore, otherCharacterStateStore, userInputStore], ([fetchedState, timeState, roomFlagsState, characterState, otherCharacterState, userInputState]) => ({
    character: fetchedState.character,
    userInput: userInputState,
    backstories: fetchedState.backstories,
    alibis: fetchedState.alibis,
    explore: {
        time: timeState.time,
        roomFlags: roomFlagsState,
        characterState: characterState,
        otherCharacterState: otherCharacterState
    }
}));
export function makeBackgrounds(folder, keys) {
    const backgrounds = {};
    keys.forEach(key => {
        backgrounds[key] = `/NoTimeToStalk/assets/backgrounds/${folder}/${key}.jpg`;
    });
    return backgrounds;
}
export const chapterStore = writable("introContext");
export function postInfo() {
    const body = Object.assign({ password: localStorage.getItem("password") }, get_store_value(postDataStore));
    const json = JSON.stringify(body);
    localStorage.setItem("body", json);
    // fetch(`${apiUrl}/game`, {
    //   method: "POST",
    //   body: json,
    //   headers: { 'Content-Type': 'application/json' },
    // })
}
